<template>
  <div class="list-test-drive">
    <KTCodePreview v-bind:title="'Danh sách đăng ký lái thử'">
      <!-- Toolbar Section -->
      <template v-slot:toolbar>
        <b-row>
          <!-- View Toggle Buttons -->
          <div class="btn-group mr-3">
            <b-button
              size="sm"
              :variant="viewMode === 'list' ? 'primary' : 'light'"
              @click="viewMode = 'list'"
              class="font-weight-bolder"
            >
              <i class="fas fa-list"></i> Danh sách
            </b-button>
            <b-button
              size="sm"
              :variant="viewMode === 'calendar' ? 'primary' : 'light'"
              @click="viewMode = 'calendar'"
              class="font-weight-bolder"
            >
              <i class="fas fa-calendar-alt"></i> Lịch
            </b-button>
          </div>

          <b-dropdown size="sm" right>
            <template slot="button-content">
              <i style="font-size: 1rem" class="fas fa-cog"></i>
              <span class="font-weight-bolder">Thao tác</span>
            </template>

            <b-dropdown-item @click="handleExportExcel" v-if="canExport">
              <span>
                <i style="font-size: 1rem" class="far fa-file-excel"></i>
                &nbsp; Xuất Excel</span
              >
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            class="font-weight-bolder ml-3"
            @click="createNewTestDrive"
            size="sm"
            variant="primary"
            v-if="canInsert"
          >
            <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
          </b-button>
        </b-row>
      </template>

      <!-- Main Content Section -->
      <template v-slot:preview>
        <!-- Filter Section -->
        <div class="d-flex mb-5">
          <!-- Fields filter -->
          <div class="flex-grow-1">
            <b-row class="mb-5">
              <b-col class="d-flex align-items-center">
                <b-input
                  size="sm"
                  placeholder="Mã/Tên sản phẩm"
                  v-model="filters.productName"
                  append-icon="search"
                  single-line
                  hide-details
                  v-on:keyup.enter="onFilter()"
                ></b-input>
              </b-col>

              <b-col>
                <b-input
                  size="sm"
                  placeholder="Biển số"
                  v-model="filters.licensePlate"
                  append-icon="search"
                  single-line
                  hide-details
                  v-on:keyup.enter="onFilter()"
                ></b-input>
              </b-col>

              <b-col>
                <auto-suggest
                  :model.sync="customerSearchText"
                  :suggestions="customerSuggestions"
                  :placeholder="'Khách hàng'"
                  :suggestion-name="'fullName'"
                  @change="onCustomerSearch"
                  @select="selectCustomer"
                  class="w-100"
                >
                </auto-suggest>
              </b-col>

              <b-col>
                <auto-suggest
                  :model.sync="employeeSearchText"
                  :suggestions="employeeSuggestions"
                  :placeholder="'Người sử dụng'"
                  :suggestion-name="'displayName'"
                  @change="onEmployeeSearch"
                  @select="selectEmployee"
                  class="w-100"
                >
                </auto-suggest
              ></b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="filters.status"
                  :options="statusOptions"
                  value-field="id"
                  disabled-field="notEnabled"
                ></b-form-select>
              </b-col>

              <b-col>
                <b-form-select
                  size="sm"
                  class="select-style"
                  v-model="filters.reason"
                  :options="reasonOptions"
                  value-field="id"
                  disabled-field="notEnabled"
                ></b-form-select>
              </b-col>

              <b-col>
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control form-control-sm"
                  v-model="filters.fromDate"
                  :config="configs.date"
                >
                </date-picker>
              </b-col>

              <b-col>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control form-control-sm"
                  v-model="filters.toDate"
                  :config="configs.date"
                >
                </date-picker>
              </b-col>
            </b-row>
          </div>
          <!-- Action filters -->
          <div
            class="d-flex align-items-center flex-column justify-content-center ml-5"
          >
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              class="mb-5"
              @click="onFilter"
              >Lọc</b-button
            >
            <b-button
              style="font-weight: 600; width: 70px"
              size="sm"
              v-b-tooltip.hover
              title="Reset dữ liệu"
              @click="resetFilters"
              variant="secondary"
            >
              <i style="padding-right: 0" class="fa fa-redo"></i>
            </b-button>
          </div>
        </div>

        <!-- <b-row>
          <b-col v-if="viewMode === 'list'">
            <div class="d-flex justify-content-end">
              <p
                class="mt-3 text-dark"
                style="font-weight: 500; font-size: 13px"
              >
                {{ fromNo }} - {{ toNo }} /
                {{ convertPrice(paginations.total) }}
              </p>
            </div>
          </b-col>
        </b-row> -->

        <!-- List View -->
        <div v-if="viewMode === 'list'">
          <table
            v-if="!isLoading"
            class="table table-bordered-list table-hover col-md-12"
          >
            <thead>
              <tr>
                <th class="text-center">Ngày đăng ký</th>
                <th class="text-center">Sản phẩm / Biển số</th>
                <th class="text-center">Người sử dụng</th>
                <th class="text-center">Mục đích</th>
                <th class="text-center">Lý do sử dụng</th>
                <th class="text-center">Trạng thái</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(testDrive, i) in testDrives">
                <!-- Subheader -->
                <tr v-if="testDrive" :key="`header-${i}`">
                  <td
                    colspan="12"
                    style="
                      padding: 8px !important;
                      border-bottom: none !important;
                    "
                  >
                    <div
                      class="d-flex flex-wrap mt-2"
                      style="font-size: 0.87rem"
                    >
                      <span class="mr-4 d-flex align-items-center">
                        <i class="fas fa-store-alt mr-2 text-primary"></i>
                        <div>
                          <b>{{
                            testDrive.storeName || 'Không có mã showroom'
                          }}</b>
                        </div>
                      </span>
                      <span class="mr-4 d-flex align-items-center">
                        <i class="far fa-clock text-primary mr-2"></i>
                        Bắt đầu:
                        <span class="text-primary font-weight-bold ml-1">{{
                          testDrive.startTime
                        }}</span>
                      </span>
                      <span class="mr-4 d-flex align-items-center">
                        <i class="fas fa-clock text-primary mr-2"></i>
                        Kết thúc:
                        <span class="text-primary font-weight-bold ml-1">{{
                          testDrive.endTime
                        }}</span>
                      </span>
                      <span class="mr-4 d-flex align-items-center">
                        <i class="fas fa-road text-primary mr-2"></i>
                        Quãng đường:
                        <span class="text-primary font-weight-bold ml-1">{{
                          calculateDistance(testDrive)
                        }}</span>
                      </span>
                    </div>
                  </td>
                </tr>

                <!-- Thông tin chi tiết -->
                <tr v-if="testDrive" :key="`detail-${i}`" class="hover-row">
                  <td class="tdTextAlign">
                    <div class="text-center">
                      <span
                        v-text="testDrive.registrationDate"
                        class="d-block font-weight-medium"
                      ></span>
                    </div>
                  </td>
                  <td class="tdTextAlign">
                    <div>
                      <span
                        v-text="testDrive.productName"
                        class="d-block white-space font-weight-medium"
                      ></span>
                      <p
                        class="text-imei-no mt-1"
                        v-if="testDrive.licensePlate"
                      >
                        <i class="fas fa-id-card mr-1"></i> Biển số:
                        <span class="font-weight-medium">{{
                          testDrive.licensePlate
                        }}</span>
                      </p>
                    </div>
                  </td>
                  <td class="tdTextAlign">
                    <div>
                      <span
                        v-text="testDrive.employeeName || '-'"
                        class="d-block font-weight-medium"
                      ></span>
                    </div>
                  </td>
                  <td class="tdTextAlign">
                    <div>
                      <span
                        v-text="testDrive.purpose || '-'"
                        class="d-block font-weight-medium"
                      ></span>
                    </div>
                  </td>
                  <td class="tdTextAlign wrapword">
                    <div>
                      <span
                        v-text="getReasonText(testDrive.reason).text || '-'"
                        class="d-block font-weight-medium"
                      ></span>
                    </div>
                  </td>
                  <td class="tdTextAlign">
                    <div class="text-center">
                      <span
                        v-text="getStatusConfig(testDrive.status).text"
                        v-bind:class="getStatusConfig(testDrive.status).class"
                        class="label font-weight-bold label-lg label-inline"
                        style="width: max-content"
                      ></span>
                    </div>
                  </td>
                  <td class="tdTextAlign">
                    <div class="d-flex">
                      <b-dropdown
                        size="sm"
                        id="dropdown-left"
                        no-caret
                        right
                        variant="link"
                        toggle-class="p-0 border-0 shadow-none"
                      >
                        <template slot="button-content">
                          <i class="flaticon2-settings text-primary"></i>
                        </template>
                        <b-dropdown-item
                          @click="editItem(testDrive)"
                          v-if="canEdit(testDrive)"
                        >
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem"
                              class="flaticon2-pen text-primary"
                            ></i>
                            &nbsp; Chỉnh sửa
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          @click="showDeleteConfirmation(testDrive)"
                          v-if="canRemove(testDrive)"
                        >
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem; color: #d33"
                              class="flaticon2-rubbish-bin-delete-button"
                            ></i>
                            &nbsp; Xóa
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-divider
                          v-if="canChangeStatus(testDrive)"
                        ></b-dropdown-divider>
                        <b-dropdown-text
                          v-if="canChangeStatus(testDrive)"
                          class="dropdown-header"
                        >
                          <i class="fas fa-exchange-alt mr-1"></i>
                          Đổi trạng thái
                        </b-dropdown-text>
                        <template v-if="canChangeStatus(testDrive)">
                          <b-dropdown-item
                            v-for="statusOption in getAvailableStatuses(
                              testDrive,
                            )"
                            :key="statusOption.id"
                            @click="changeStatus(testDrive, statusOption.id)"
                          >
                            <span style="color: #3f4254; font-size: 12px">
                              <i
                                style="font-size: 1rem"
                                :class="statusOption.icon"
                              ></i>
                              &nbsp; {{ statusOption.text }}
                            </span>
                          </b-dropdown-item>
                        </template>
                      </b-dropdown>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <vcl-table
            v-if="isLoading"
            :speed="5"
            :animate="true"
            :columns="6"
          ></vcl-table>

          <!-- Pagination for List View -->
          <b-row>
            <b-col>
              <p class="mt-3 text-dark" style="font-weight: 500">
                Tổng số:
                {{ convertPrice(paginations.total) }}
              </p>
            </b-col>
            <b-col>
              <b-pagination-nav
                class="custom-pagination"
                v-if="paginations.totalPages >= 2"
                :link-gen="linkGen"
                :number-of-pages="paginations.totalPages"
                use-router
                @change="onPageChange"
                :value="paginations.currentPage"
                align="right"
                first-class="page-item-first btn btn-icon btn-sm m-1"
                prev-class="page-item-prev btn btn-icon btn-sm m-1"
                next-class="page-item-next btn btn-icon btn-sm m-1"
                last-class="page-item-last btn btn-icon btn-sm m-1"
                page-class="btn btn-icon btn-sm border-0 m-1"
              >
                <template v-slot:first-text>
                  <span>
                    <i class="ki ki-double-arrow-back icon-xs"></i>
                  </span>
                </template>

                <template v-slot:prev-text>
                  <i class="ki ki-arrow-back icon-xs"></i>
                </template>

                <template v-slot:next-text>
                  <i class="ki ki-arrow-next icon-xs"></i>
                </template>

                <template v-slot:last-text>
                  <span class="text-info">
                    <i class="ki ki-double-arrow-next icon-xs"></i>
                  </span>
                </template>
              </b-pagination-nav>
            </b-col>
          </b-row>
        </div>

        <!-- Calendar View -->
        <template v-else-if="viewMode === 'calendar'">
          <test-drive-calendar
            ref="testDriveCalendar"
            :test-drives="testDrives"
            :is-loading="isLoading"
            @range-updated="handleCalendarRangeUpdate"
          ></test-drive-calendar>
        </template>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Swal from 'sweetalert2';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import { convertPrice, makeToastSuccess, makeToastFaile } from '@/utils/common';
import { createFile, getFileName } from '@/utils/file-download';
import { mapActions, mapGetters } from 'vuex';
import AutoSuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import TestDriveCalendar from './TestDriveCalendar.vue';

import {
  getStartOfDay,
  getEndOfDay,
  DP_CONFIG,
  getSubtractMonths,
  getCurrentDate,
} from '@/utils/date';

import { TestDriveService } from '../../../../core/services/test-drives';

import { getCurrentUser } from '../../../../utils/currentUser';
import { TestDriveModel } from '../../posm/models/TestDrive.model';
import {
  formatDate,
  formatDateTime,
  formatDatetimeDB,
} from '../../../../utils/date';
import { handleApiError } from '../../../../utils/errorHandler';
import { PERMISSIONS } from '../../../../utils/enum';
import moment from 'moment';

export default {
  components: {
    KTCodePreview,
    VclTable,
    AutoSuggest,
    TestDriveCalendar,
  },

  data() {
    return {
      // View mode
      viewMode: 'list', // 'list' or 'calendar'
      isInitCalendar: false,

      //   Current User
      currentUser: getCurrentUser(),

      // Constants
      LIMIT_PAGE: 5,
      THREE_MONTHS_AGO: getSubtractMonths(3),
      NOW: getCurrentDate(),

      // Filters
      filters: {
        productName: '',
        licensePlate: '',
        customerId: '',
        employeeId: '',
        status: '',
        reason: '',
        fromDate: getSubtractMonths(3),
        toDate: getCurrentDate(),
      },

      // Employee search
      employeeSearchText: '',
      employeeSuggestions: [],

      // Customer search
      customerSearchText: '',
      customerSuggestions: [],

      // Configs
      configs: DP_CONFIG,

      // Options
      statusOptions: [
        {
          id: '',
          text: 'Tất cả',
        },
        ...TestDriveModel.getStatusOptions(),
      ],
      reasonOptions: [
        {
          id: '',
          text: 'Chọn lí do',
        },
        ...TestDriveModel.getReasonOptions(),
      ],
    };
  },

  computed: {
    ...mapGetters({
      testDrives: 'testDrives/getTestDrives',
      isLoading: 'testDrives/isLoading',
      error: 'testDrives/getError',
      paginations: 'testDrives/getPaginations',
    }),

    fromNo() {
      return (this.paginations.currentPage - 1) * this.LIMIT_PAGE + 1;
    },

    toNo() {
      return Math.min(
        this.LIMIT_PAGE * this.paginations.currentPage,
        this.paginations.total,
      );
    },

    canViewAll() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_VIEW_ALL);
    },

    canView() {
      return (
        this.checkPermission(PERMISSIONS.TEST_DRIVE_VIEW) || this.canViewAll
      );
    },

    canInsert() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_INSERT);
    },

    canUpdate() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_UPDATE);
    },

    canDelete() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_DELETE);
    },

    canExport() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_EXPORT);
    },

    canChangeStatusAll() {
      return this.checkPermission(PERMISSIONS.TEST_DRIVE_CHANGE_STATUS_ALL);
    },
  },

  mounted() {
    if (!this.canView) {
      this.$router.push({ name: 'dashboard' });
      makeToastFaile('Bạn không có quyền xem danh sách đăng ký lái thử');
      return;
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'CRM', route: '/crm' },
      { title: 'Danh sách đăng ký lái thử' },
    ]);
  },

  created() {
    this.fetchData();

    const savedViewMode = localStorage.getItem('testDriveViewMode');
    if (savedViewMode) {
      this.viewMode = savedViewMode;
    }
  },

  watch: {
    viewMode(newValue) {
      localStorage.setItem('testDriveViewMode', newValue);

      if (newValue === 'calendar') {
        this.isInitCalendar = true;
        this.$nextTick(() => {
          this.initializeCalendarView();
        });
      } else {
        this.isInitCalendar = false;
      }
    },
  },

  methods: {
    ...mapActions({
      fetchTestDrives: 'testDrives/fetchTestDrives',
      deleteTestDrive: 'testDrives/deleteTestDrive',
      updateTestDriveStatus: 'testDrives/updateTestDrive',

      searchCustomers: 'customers/smartSearch',
      searchEmployees: 'users/smartSearch',
    }),

    convertPrice,
    makeToastSuccess,
    makeToastFaile,

    // Format Date
    formatDate,
    formatDateTime,

    // Permission check
    checkPermission(permission) {
      return localData.checkPermission([permission]);
    },

    // Get status config
    getStatusConfig(statusId) {
      return TestDriveModel.getStatusById(statusId);
    },

    // Get reason text
    getReasonText(reasonId) {
      return TestDriveModel.getReasonById(reasonId);
    },

    // Pagination link generator
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },

    // Handle page change
    onPageChange(page) {
      this.fetchData(page);
    },

    // Reset filters
    resetFilters() {
      this.filters = {
        productName: '',
        licensePlate: '',
        customerId: '',
        status: '',
        reason: '',
        employeeId: '',
        fromDate: getSubtractMonths(3),
        toDate: this.NOW,
      };

      this.employeeSearchText = '';
      this.customerSearchText = '';
      this.customerSuggestions = [];
      this.employeeSuggestions = [];

      this.fetchData(1);
    },

    // Apply filters
    onFilter() {
      this.fetchData(1);
    },

    async initializeCalendarView() {
      const calendarRef = this.$refs.testDriveCalendar;
      const calendarType = calendarRef?.type || 'month';

      let start, end;

      const today = moment();

      switch (calendarType) {
        case 'month':
          start = today.clone().startOf('month');
          end = today.clone().endOf('month');
          break;
        case 'week':
          start = today.clone().startOf('week');
          end = today.clone().endOf('week');
          break;
        case 'day':
          start = today.clone().startOf('day');
          end = today.clone().endOf('day');
          break;
        default:
          start = today.clone().startOf('month');
          end = today.clone().endOf('month');
      }

      // Format dates
      this.filters.fromDate = formatDate(start.toDate());
      this.filters.toDate = formatDate(end.toDate());

      // Fetch data
      await this.fetchCalendarData();
    },

    // Employee search
    async onEmployeeSearch(text) {
      if (!text || text.length < 2) {
        this.employeeSuggestions = [];
        return;
      }

      clearTimeout(this.employeeSearchTimeout);

      this.employeeSearchTimeout = setTimeout(async () => {
        try {
          const { data } = await this.searchEmployees({
            keyword: text,
            storeId: this.currentUser.storeId,
            limit: 5,
          });

          this.employeeSuggestions = data;
        } catch (error) {
          this.employeeSuggestions = [];
          handleApiError(error);
        }
      }, 400);
    },

    selectEmployee(option) {
      if (option && option.item) {
        this.filters.employeeId = option.item.id;
        this.employeeSearchText = option.item.fullName;
      } else {
        this.filters.employeeId = null;
        this.employeeSearchText = '';
      }
    },

    // Customer search
    onCustomerSearch(text) {
      if (!text || text.length < 2) {
        this.customerSuggestions = [];
        return;
      }

      clearTimeout(this.customerSearchTimeout);

      this.customerSearchTimeout = setTimeout(async () => {
        try {
          const { data } = await this.searchCustomers({
            keyword: text,
            limit: 5,
          });

          this.customerSuggestions = data;
        } catch (error) {
          this.customerSuggestions = [];
          handleApiError(error);
        }
      }, 400);
    },

    selectCustomer(option) {
      if (option && option.item) {
        this.customerSearchText = option.item.fullName;
        this.filters.customerId = option.item.id;
      } else {
        this.customerSearchText = '';
        this.filters.customerId = null;
      }
    },
    // Fetch data for list view
    async fetchData(page = 1) {
      const pageNumber = page || this.$route.query.page;

      try {
        const params = {
          ...this.filters,
          page: pageNumber,
          limit: this.LIMIT_PAGE,
          fromDate: getStartOfDay(this.filters.fromDate),
          toDate: getEndOfDay(this.filters.toDate),

          ...(this.canViewAll ? {} : { storeId: this.currentUser.storeId }),
        };
        await this.fetchTestDrives(params);
      } catch (error) {
        handleApiError(error);
      }
    },

    async fetchCalendarData() {
      try {
        const params = {
          ...this.filters,
          page: 1,
          limit: 100,
          fromDate: getStartOfDay(this.filters.fromDate),
          toDate: getEndOfDay(this.filters.toDate),

          ...(this.canViewAll ? {} : { storeId: this.currentUser.storeId }),
        };
        await this.fetchTestDrives(params);
      } catch (error) {
        handleApiError(error);
      }
    },

    // Handle calendar range update
    async handleCalendarRangeUpdate({ start, end }) {
      this.filters.fromDate = formatDate(start);
      this.filters.toDate = formatDate(end);

      if (!this.isInitCalendar) {
        await this.fetchCalendarData();
      }
      this.isInitCalendar = true;
    },

    // Create new test drive
    createNewTestDrive() {
      if (!this.canInsert) {
        makeToastFaile('Bạn không có quyền thêm mới đăng ký lái thử');
        return;
      }
      this.$router.push({ name: 'test-drive.create' });
    },

    // Edit test drive
    editItem(item) {
      if (!this.canEdit(item)) {
        makeToastFaile('Bạn không có quyền chỉnh sửa đăng ký lái thử này');
        return;
      }
      this.$router.push({
        name: 'test-drive.edit',
        query: { id: item.id },
      });
    },

    canEdit(item) {
      return (
        this.canUpdate && Number(item.status) <= TestDriveModel.STATUS.CANCELLED
      );
    },

    canRemove(item) {
      // Can delete if status is registered or confirmed AND user has delete permission
      return (
        this.canDelete &&
        (Number(item.status) === TestDriveModel.STATUS.REGISTERED ||
          Number(item.status) === TestDriveModel.STATUS.CONFIRMED)
      );
    },

    canChangeStatus(item) {
      return (
        (this.canChangeStatusAll || this.canUpdate) &&
        Number(item.status) < TestDriveModel.STATUS.COMPLETED
      );
    },

    // Get available statuses for changing
    getAvailableStatuses(item) {
      return TestDriveModel.getAvailableNextStatuses(item.status);
    },

    // Change status
    async changeStatus(item, newStatus) {
      if (!this.canChangeStatus(item)) {
        makeToastFaile(
          'Bạn không có quyền thay đổi trạng thái đăng ký lái thử này',
        );
        return;
      }

      if (
        newStatus === TestDriveModel.STATUS.COMPLETED &&
        item.kmAfterDrive === null
      ) {
        this.$router.push({
          name: 'test-drive.edit',
          query: { id: item.id, status: TestDriveModel.STATUS.COMPLETED },
        });
        makeToastFaile(
          'Vui lòng cập nhật số km sau khi lái thử trước khi hoàn thành',
        );
        return;
      }

      try {
        await this.updateTestDriveStatus({
          id: item.id,
          data: {
            status: newStatus,
            storeId: item.storeId,
            demoTicketId: item.demoTicketId,
            kmAfterDrive: item.kmAfterDrive,
            kmBeforeDrive: item.kmBeforeDrive,
            startTime: formatDatetimeDB(item.startTime),
            endTime: formatDatetimeDB(item.endTime),
          },
        });

        await this.fetchData(this.paginations.currentPage);
        makeToastSuccess('Cập nhật trạng thái thành công');
      } catch (error) {
        handleApiError(error);
      }
    },

    // Show delete confirmation
    showDeleteConfirmation(item) {
      if (!this.canRemove(item)) {
        makeToastFaile('Bạn không có quyền xóa đăng ký lái thử này');
        return;
      }

      Swal.fire({
        title: 'Xóa đăng ký lái thử!',
        text: 'Bạn có chắc muốn xóa đăng ký lái thử này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'center',
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.deleteTestDrive(item.id);

            makeToastSuccess('Xóa thành công');
            this.fetchData(this.paginations.currentPage);
          } catch (error) {
            handleApiError(error);
          }
        }
      });
    },

    // Handle export excel with date range
    async handleExportExcel() {
      if (!this.canExport) {
        makeToastFaile('Bạn không có quyền xuất Excel');
        return;
      }

      try {
        const params = {
          ...this.filters,
          fromDate: getStartOfDay(this.filters.fromDate),
          toDate: getEndOfDay(this.filters.toDate),

          ...(this.canViewAll ? {} : { storeId: this.currentUser.storeId }),
        };

        const response = await TestDriveService.exportExcel(params);

        const fileName =
          getFileName(response) || 'danh-sach-dang-ky-lai-thu.xlsx';
        createFile(response.data, fileName);
        makeToastSuccess('Xuất Excel thành công');
      } catch (error) {
        handleApiError(error);
      }
    },

    calculateDistance(item) {
      const afterDrive = parseFloat(item.kmAfterDrive);
      const beforeDrive = parseFloat(item.kmBeforeDrive);

      if (isNaN(afterDrive) || isNaN(beforeDrive)) return '0 Km';

      return Number(afterDrive - beforeDrive).toFixed(1) + ' Km';
    },
  },
};
</script>
<style lang="scss" scoped>
.list-test-drive {
  .btn.btn-icon.btn-sm {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .dropdown-header {
    color: #3699ff !important;
  }

  .white-space {
    white-space: pre-wrap;
  }

  /* Thêm các style mới */
  .bg-light-primary {
    background-color: rgba(54, 153, 255, 0.1);
  }

  .hover-row:hover {
    background-color: #f9f9f9;
  }

  .font-weight-medium {
    font-weight: 500;
  }

  th {
    font-weight: 600;
    background-color: #f3f6f9;
  }

  .table-bordered-list th {
    border-bottom: 2px solid #e4e6ef;
  }

  .dropdown-item:hover {
    background-color: #f3f6f9;
  }
}
</style>
<style scoped>
input.form-control {
  border: 1px solid #ced4da;
}

.sttProClass {
  width: 20px;
}

.nameProClass {
  width: 30%;
  padding-left: 8px;
  align-items: center;
}

.statusProClass {
  width: 12%;
}

.actionProClass {
  width: 7%;
}

.white-space {
  white-space: pre-wrap;
}

.select-style {
  height: 31px;
}

/* View toggle button styles */

.btn-group .btn.btn-primary {
  background-color: #3699ff;
  border-color: #3699ff;
}

.btn-group .btn.btn-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #7e8299;
}

.btn-group .btn.btn-light:hover {
  background-color: #e4e6ef;
  border-color: #e4e6ef;
}

.table-bordered-list {
  border-collapse: collapse;
  width: 100%;
}

.table-bordered-list th,
.table-bordered-list td {
  border: 1px solid #ebedf3;
  padding: 0.75rem;
  vertical-align: middle;
}

.tdTextAlign {
  text-align: left;
  vertical-align: middle !important;
}

.wrapword {
  white-space: normal;
  word-wrap: break-word;
}

.text-imei-no {
  font-size: 13px;
  color: #7e8299;
  margin-bottom: 0;
}

.white-space {
  white-space: normal;
}

.dashed {
  border-top: 1px dashed #ebedf3;
  margin: 5px 0;
}

.column-gap {
  column-gap: 10px;
}
</style>
